export enum ZoomControlPosition {
  center = 'center',
  top = 'top',
}
